import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

interface Props {
  restaurantId: string;
  tableNumber: string;
  customText: string;
  size: number;
}

export const QrCodeGenerator = React.forwardRef<HTMLDivElement, Props>(
  ({ restaurantId, tableNumber, customText, size }, ref) => {
    const qrUrl = `${window.location.origin}/customer/restaurants/${restaurantId}?table=${tableNumber}`;
    const logo = '/logo.svg';

    return (
      <Card elevation={3}>
        <CardContent>
          <Box
            ref={ref}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              p: 1,
              width: '100%',
              aspectRatio: '1/1',
              maxWidth: size,
              maxHeight: size,
              margin: '0 auto',
              overflow: 'hidden',
            }}
          >
            <Typography variant="h3" align="center" gutterBottom>
              <strong>#{tableNumber}</strong>
            </Typography>
            <QRCodeSVG
              value={qrUrl}
              size={Math.min(size, window.innerWidth - 32)}
              level="H"
              imageSettings={{
                src: logo,
                width: Math.min(size, window.innerWidth - 32) * 0.2,
                height: Math.min(size, window.innerWidth - 32) * 0.2,
                excavate: true,
              }}
            />
            <Typography variant="body2" align="center">
              {customText}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }
);
